var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video-modal" },
    [
      _c("modal", {
        ref: "videoModal",
        attrs: { video: _vm.videoId },
        on: { close: _vm.clearVideo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }